module.exports = __webpack_public_path__ + "img/dd-logo-toyota.e30d42b1.png";